import APIController from '../core-api-controller';

export const fetchPermissionsApi = () => {
  const path = `${APIController.endpointApi}/permissions`;
  return APIController.getApiCallback(path);
};
